"use strict";

var _jsxRuntime = require("react/jsx-runtime");
module.exports = ({
  title,
  titleId,
  size,
  color,
  ...props
}) => /*#__PURE__*/(0, _jsxRuntime.jsxs)("svg", {
  ...props,
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24",
  height: size,
  width: size,
  fill: color,
  role: title ? 'img' : undefined,
  "aria-hidden": !title,
  "aria-labelledby": titleId,
  children: [title ? /*#__PURE__*/(0, _jsxRuntime.jsx)("title", {
    id: titleId,
    children: title
  }) : null, /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
    fillRule: "evenodd",
    d: "m12 13.558-6.575 6.18a1 1 0 0 1-1.379-.028l.235.234a.957.957 0 0 1-.004-1.35l6.376-6.373-.112-.114L4.26 5.431a1.011 1.011 0 0 1 .028-1.383l-.235.234a.953.953 0 0 1 1.35-.003L12 10.874l6.597-6.595a.952.952 0 0 1 1.35.003l-.234-.234c.37.37.386.993.027 1.383l-6.28 6.676-.113.114 6.376 6.374a.957.957 0 0 1-.004 1.35l.235-.235a1 1 0 0 1-1.38.029L12 13.558Z",
    clipRule: "evenodd"
  })]
});